import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=3e57bb7e&scoped=true&"
import script from "./StartButton.vue?vue&type=script&lang=js&"
export * from "./StartButton.vue?vue&type=script&lang=js&"
import style0 from "./StartButton.vue?vue&type=style&index=0&id=3e57bb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57bb7e",
  null
  
)

export default component.exports